import React from 'react'
import CollectionMainPage from "../page/CollectionMainPage"



function AnkletsPage({categoryType}) {
  return (
    <CollectionMainPage categoryType={categoryType}/>
  )
}




export default AnkletsPage